var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransactionsgreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mingcute:transfer-line",
    clipPath: "url(#clip0_2352_6010)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.1659 9.91722C14.3464 9.91742 14.5201 9.98655 14.6514 10.1105C14.7826 10.2344 14.8616 10.4038 14.8722 10.584C14.8828 10.7643 14.8242 10.9417 14.7083 11.0802C14.5924 11.2186 14.428 11.3076 14.2488 11.3289L14.1659 11.3339H4.54247L6.16667 12.9581C6.29371 13.0856 6.36747 13.2566 6.37296 13.4365C6.37845 13.6164 6.31527 13.7916 6.19625 13.9266C6.07722 14.0616 5.91128 14.1462 5.73213 14.1633C5.55298 14.1803 5.37404 14.1286 5.23167 14.0185L5.16509 13.9597L2.45217 11.2468C1.98113 10.7764 2.28288 9.9838 2.9218 9.92147L3.00326 9.91722H14.1659ZM10.8318 3.04143C10.9537 2.91947 11.116 2.84621 11.2881 2.83538C11.4603 2.82456 11.6305 2.87692 11.7668 2.98264L11.8333 3.04143L14.5463 5.75434C15.0173 6.22468 14.7155 7.0173 14.0766 7.07964L13.9952 7.08389H2.83255C2.65201 7.08369 2.47836 7.01455 2.34708 6.89062C2.2158 6.76668 2.1368 6.59729 2.12622 6.41706C2.11564 6.23684 2.17428 6.05937 2.29015 5.92092C2.40603 5.78248 2.5704 5.6935 2.74967 5.67218L2.83255 5.66722H12.456L10.8318 4.04301C10.699 3.91018 10.6244 3.73004 10.6244 3.54222C10.6244 3.35439 10.699 3.17426 10.8318 3.04143Z",
    fill: "#6CE3C4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2352_6010"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionsgreen);
export default __webpack_public_path__ + "static/media/Transactions green.fcb86a1b16c2d68bd17928996b42c830.svg";
export { ForwardRef as ReactComponent };